import React from "react";

const Breadcrumb = ({ title, subtitle = null, actions = null }) => {
  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
      <div>
        <h5 className='fw-bold mb-0' style={{ color: 'var(--hs-text-primary)' }}>{title}</h5>
        {subtitle && <p className="mb-0 text-sm" style={{ color: 'var(--hs-text-secondary)' }}>{subtitle}</p>}
      </div>
      {actions && (
        <div className="d-flex align-items-center gap-3">
          {actions}
        </div>
      )}
    </div>
  );
};

export default Breadcrumb;
